
import { getErrorss } from '../../../functions/errors/GetErrors'
import { ACCESS_KEY, urlAPI } from '../../../urls'
import { setAdvertises } from '../../slices/advertisesSlice'
import { dataFetchingFinish, dataFetchingStart, modalSlice } from '../../slices/modalSlice'
import { type AppDispatch, type RootState } from '../../store'
import _ from 'lodash'

import { toUTCWithOffset } from '../../../functions/agent/date/toUTCWithOffset'
import { sendNotification } from '../../../functions/shared/notifications/sendNotification'
import { getQueryAdvertises } from '../../../functions/shared/api/queries/getQueryAdvertises'
import { getCurrentDubaiDate } from '../../../functions/agent/date/getCurrentDubaiDate'
import { isPortalLinkEntry, normalizeLinksArray, normalizeLinkStatus } from '../../../functions/agent/advertises/portalLinks'

export const setAdvertiseLinksStatus = (data: Record<string, unknown>, id: number, modalID: string) => async (dispatch: AppDispatch, getState: () => RootState) => {
    const jwt = window.localStorage.getItem(ACCESS_KEY)

    const currentDubaiDate = getCurrentDubaiDate()
    const inMomentOfferForAdmin = toUTCWithOffset(currentDubaiDate, 1)

    const advertise = _.find(getState().advertises.advertises, (advertise: any) => advertise.id === id)
    let Statuses: string[] = []
    let Links: any[] = []
    let RejectReason: any = null

    if (modalID === 'check_advertisement_links_modal') {
        const existingLinks = normalizeLinksArray(advertise?.attributes?.Links)
        const incomingLinks = (data?.Links as Array<{ Status?: boolean }>) ?? []
        const portalReviews = Array.isArray(data?.PortalLinksReview) ? data.PortalLinksReview as Array<Record<string, any>> : []
        const updatesByIndex = new Map<number, Record<string, any>>()
        const hasOwn = (obj: Record<string, any>, key: string) => Object.prototype.hasOwnProperty.call(obj, key)

        portalReviews.forEach((review) => {
            if (typeof review?.SourceIndex === 'number') {
                updatesByIndex.set(review.SourceIndex, review)
            }
        })

        Links = existingLinks.map((currentLink, index) => {
            const reviewed = incomingLinks[index]
            const portalUpdate = updatesByIndex.get(index)
            if (isPortalLinkEntry(currentLink)) {
                if (portalUpdate == null) {
                    return currentLink
                }

                const nextPortal = hasOwn(portalUpdate, 'Portal')
                    ? String(portalUpdate?.Portal ?? '').trim()
                    : String((currentLink as any)?.Portal ?? (currentLink as any)?.Title ?? '').trim()
                const nextLink = hasOwn(portalUpdate, 'Link')
                    ? String(portalUpdate?.Link ?? '').trim()
                    : String((currentLink as any)?.Link ?? '').trim()
                const nextComment = hasOwn(portalUpdate, 'Comment')
                    ? String(portalUpdate?.Comment ?? '')
                    : hasOwn(portalUpdate, 'Feedback')
                        ? String(portalUpdate?.Feedback ?? '')
                        : String((currentLink as any)?.Comment ?? (currentLink as any)?.Feedback ?? '')
                const nextDisabled = hasOwn(portalUpdate, 'IsDisabled')
                    ? Boolean(portalUpdate?.IsDisabled)
                    : hasOwn(portalUpdate, 'Disabled')
                        ? Boolean(portalUpdate?.Disabled)
                        : Boolean((currentLink as any)?.IsDisabled ?? (currentLink as any)?.Disabled)

                return {
                    ...currentLink,
                    Portal: nextPortal,
                    Title: nextPortal.length > 0 ? nextPortal : ((currentLink as any)?.Title ?? ''),
                    Link: nextLink,
                    Status: normalizeLinkStatus(portalUpdate?.Status ?? (currentLink as any)?.Status),
                    Comment: nextComment,
                    Feedback: nextComment,
                    IsDisabled: nextDisabled,
                    Disabled: nextDisabled
                }
            }
            if (reviewed?.Status == null) {
                return currentLink
            }
            return {
                ...currentLink,
                Status: reviewed.Status ? 'Approved' : 'Rejected'
            }
        })

        const reviewedTrakheesi = existingLinks
            .map((currentLink, index) => ({ currentLink, review: incomingLinks[index] }))
            .filter(({ currentLink, review }) => !isPortalLinkEntry(currentLink) && review?.Status != null)
        const isTrakheesiReviewApplied = reviewedTrakheesi.length > 0
        const isAllTrakheesiApproved = isTrakheesiReviewApplied && reviewedTrakheesi.every(({ review }) => review?.Status === true)

        const isPortalReviewApplied = portalReviews.length > 0
        const isAnyPortalRejected = portalReviews.some((review) => normalizeLinkStatus(review?.Status) === 'Rejected')
        const isAllPortalApproved = isPortalReviewApplied && portalReviews.every((review) => {
            const status = normalizeLinkStatus(review?.Status)
            const disabled = Boolean(review?.IsDisabled ?? review?.Disabled)
            return status === 'Approved' || disabled
        })

        if (isTrakheesiReviewApplied) {
            Statuses = isAllTrakheesiApproved ? ['Links approved'] : ['Links rejected']
            RejectReason = isAllTrakheesiApproved ? null : data?.RejectReason
        } else if (isPortalReviewApplied) {
            Statuses = isAnyPortalRejected || !isAllPortalApproved ? ['Links rejected'] : ['Links approved']
            const rejectedComments = portalReviews
                .filter((review) => normalizeLinkStatus(review?.Status) === 'Rejected')
                .map((review) => String(review?.Comment ?? review?.Feedback ?? '').trim())
                .filter((comment) => comment.length > 0)

            const fallbackRejectReason = rejectedComments.join(' | ').trim()
            const requestRejectReason = String((data?.RejectReason as string) ?? '').trim()
            const isRejectedFlow = Statuses.includes('Links rejected')
            RejectReason = isRejectedFlow
                ? (requestRejectReason.length > 0 ? requestRejectReason : (fallbackRejectReason.length > 0 ? fallbackRejectReason : null))
                : null
        } else {
            Statuses = advertise?.attributes?.Statuses ?? []
            RejectReason = advertise?.attributes?.RejectReason ?? null
        }
    } else {
        const incomingLinks = (data?.Links as Array<{ Status?: boolean }>) ?? []
        const existingLinks = normalizeLinksArray(advertise?.attributes?.Links)
        const isAllApproved = _.every(incomingLinks, (link: { Status?: boolean }) => link?.Status === true)
        Statuses = isAllApproved ? ['Completed'] : ['Ads removing rejected']
        Links = _.map(incomingLinks, (link: { Status?: boolean }, index) => ({
            Link: (existingLinks?.[index] as any)?.Link,
            Status: link?.Status ? 'Approved' : 'Rejected',
            Title: (existingLinks?.[index] as any)?.Title,
            Trakheesi_id: (existingLinks?.[index] as any)?.Trakheesi_id
        }))
        RejectReason = !isAllApproved ? data?.RejectReason : null
    }

    try {
        dispatch(dataFetchingStart())
        const sendObject = {
            method: 'PUT',
            collection: 'unit-advertises',
            id,
            query: getQueryAdvertises() , 
            body: {
                ...advertise?.attributes,
                Links,
                Statuses,
                RejectReason,
                Notify: 'Agent'
            }
        }

        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            body: JSON.stringify(sendObject),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            }
        })
        const dataJSON = await response.json()
        if (dataJSON.success) {
            if (dataJSON.response.error != null) {
                dispatch(modalSlice.actions.dataFetchingFinish())
                return { ...dataJSON, textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
            } else {
                let notifyRule: string, notifyMessage: string
                if (modalID === 'check_advertisement_links_modal') {
                    if (Statuses.includes('Links approved')) {
                        notifyRule = 'user-advertise-approved'
                        notifyMessage = 'The notify links are successfully approved'
                    } else {
                        notifyRule = 'user-advertise-rejected'
                        notifyMessage = 'The notify links are rejected'
                    }
                } else {
                    if (Statuses.includes('Completed')) {
                        notifyRule = 'user-advertise-approved'
                        notifyMessage = 'The notify links removing is successfully approved'
                    } else {
                        notifyRule = 'user-advertise-rejected'
                        notifyMessage = 'The notify links removing is rejected'
                    }
                }
                await sendNotification(inMomentOfferForAdmin, Number(advertise?.attributes?.User?.data?.id), id, notifyRule, notifyMessage)
                dispatch(dataFetchingFinish())
                dispatch(setAdvertises(
                    dataJSON.response.data
                ))
                return { ...dataJSON, textNavigate: -1, isSuccessful: true, textNotification: 'You have successfully reviewed the Trakheesi ID(s)' }
            }
        } else {
            dispatch(dataFetchingFinish())
            return { textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
        }
    } catch (error) {
        console.log(error)
        dispatch(dataFetchingFinish())
        return { textNavigate: '', isSuccessful: false, textNotification: 'Something went wrong, try again.' }
    }
}
